import { useState, useEffect } from 'react'
import * as umServiceURL from './umServiceURL'
import useCallApi from '../../utilities/axios'

export type ConsiderationFormType = {
    nameTH: string
    nameEN: string
    weekNumber: number
    submittedTypeID: string[]
}

export type PutOrderConsiderationResponse = {
    message: string
}

type UseSettingConsiderationProps = {
    id?: string
    irb?: string
}
export const useSettingConsideration = (props: UseSettingConsiderationProps = { id: undefined, irb: undefined }) => {
    const { id, irb } = props
    const [settingConsideration, setSettingConsideration] = useState<ConsiderationFormType>()

    useEffect(() => {
        if (id && irb) {
            getSettingConsideration(id, irb)
        }
    }, [])

    const callApi = useCallApi()

    const getSettingConsideration = async (approveStatusID: string, irb: string) => {
        const { data } = await callApi.axiosGet({
            url: `${umServiceURL.getSettingConsideration}/${approveStatusID}/${irb}`,
        })

        setSettingConsideration(data)
        return data
    }

    const putSettingConsideration = async (values: ConsiderationFormType, approveStatusID: string, irb: string) => {
        const { data } = await callApi.axiosPut<any>({
            url: `${umServiceURL.getSettingConsideration}/${approveStatusID}/${irb}`,
            params: values,
        })

        return data
    }

    const putOrderSettingConsideration = async (
        values: number[],
        userID: number,
        approveStatusID: string | null,
        irb: number,
    ) => {
        const { data } = await callApi.axiosPut<PutOrderConsiderationResponse>({
            url: `${umServiceURL.putOrderSettingConsideration}/${approveStatusID}`,
            params: { listID: values, irb: irb },
        })

        return data
    }

    return {
        settingConsideration,
        putSettingConsideration,
        putOrderSettingConsideration,
    }
}
